var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSantaHat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hata"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd4755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca2e43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hata",
    id: "hate",
    x1: 210.782,
    x2: 389.375,
    y1: 337.459,
    y2: 337.459,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hatb"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a72b2b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#a52a2b",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#a2292e",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#9d2731",
    stopOpacity: 0.566
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#972436",
    stopOpacity: 0.986
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatb",
    id: "hatf",
    x1: 489.787,
    x2: 539.271,
    y1: 339.627,
    y2: 348.233,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatb",
    id: "hatg",
    x1: 531.802,
    x2: 483.034,
    y1: 434.917,
    y2: 347.683,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hata",
    id: "hath",
    x1: 175.749,
    x2: 330.721,
    y1: 402.623,
    y2: 354.682,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatb",
    id: "hati",
    x1: 280.654,
    x2: 280.654,
    y1: 361.378,
    y2: 292.029,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatb",
    id: "hatj",
    x1: 370.297,
    x2: 444.515,
    y1: 360.433,
    y2: 320.59,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hatk",
    x1: 456.931,
    x2: 486.031,
    y1: 386.02,
    y2: 386.02,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#fe646f",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fe646f",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#fe646f",
    stopOpacity: 0.196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#fe646f",
    stopOpacity: 0.346
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fe646f",
    stopOpacity: 0.538
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#fe646f",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe646f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hatl",
    x1: 280.654,
    x2: 280.654,
    y1: 304.636,
    y2: 214.229,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3dafe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hatc"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3dafe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#b1d8fc",
    stopOpacity: 0.033
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#abd4fa",
    stopOpacity: 0.126
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#a3cdf5",
    stopOpacity: 0.277
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#97c3ee",
    stopOpacity: 0.487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#88b7e6",
    stopOpacity: 0.752
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatc",
    id: "hatm",
    x1: 280.654,
    x2: 280.654,
    y1: 243.328,
    y2: 180.353,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatc",
    id: "hatn",
    x1: 421.671,
    x2: 486.206,
    y1: 228.982,
    y2: 195.639,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatc",
    id: "hato",
    x1: 212.06,
    x2: 230.345,
    y1: 222.254,
    y2: 186.759,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatc",
    id: "hatp",
    x1: 376.301,
    x2: 394.586,
    y1: 224.855,
    y2: 177.529,
    gradientTransform: "scale(1 -1) rotate(-25.03 -946.92 124.527)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hatq",
    cx: 446.89,
    cy: 71.373,
    r: 58.646,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#fdeea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#fdea96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fce37a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#fbda53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#face22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hatr",
    cx: 436.887,
    cy: 71.16,
    r: 79.471,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#fe9738",
    stopOpacity: 0.009
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#fe9738",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fe9738",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#fe9738",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#fe9738",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fe9738",
    stopOpacity: 0.389
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#fe9738",
    stopOpacity: 0.533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759,
    stopColor: "#fe9738",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#fe9738",
    stopOpacity: 0.883
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#fe9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#fe9738",
    stopOpacity: 0.987
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#fe9738",
    stopOpacity: 0.948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#fe9738",
    stopOpacity: 0.881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#fe9738",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#fe9738",
    stopOpacity: 0.664
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#fe9738",
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#fe9738",
    stopOpacity: 0.337
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#fe9738",
    stopOpacity: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738",
    stopOpacity: 0.012
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hats",
    x1: 449.558,
    x2: 462.254,
    y1: 35.912,
    y2: 35.912,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hatd"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#433f43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#373537",
    stopOpacity: 0.269
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatd",
    id: "hatt",
    x1: 460.756,
    x2: 448.12,
    y1: 36.762,
    y2: 34.532,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#hatd",
    id: "hatu",
    x1: 457.658,
    x2: 450.225,
    y1: 50.077,
    y2: 67.544,
    gradientTransform: "matrix(1 0 0 -1 0 514)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hate)",
    d: "M453.2 483.9c1.5-4.7 31.6-122.5-131.4-200.3l92.3-198c163.2 79.8 41.7 391.6 39.1 398.3z",
    opacity: 1,
    "data-original": "url(#hate)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatf)",
    d: "M453.2 483.9c1.5-4.7 31.6-122.5-131.4-200.3l92.3-198c163.2 79.8 41.7 391.6 39.1 398.3z",
    opacity: 1,
    "data-original": "url(#hatf)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatg)",
    d: "M453.2 483.9c1.5-4.7 31.6-122.5-131.4-200.3l92.3-198c163.2 79.8 41.7 391.6 39.1 398.3z",
    opacity: 1,
    "data-original": "url(#hatg)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hath)",
    d: "M410.6 356.8 36.7 182.5S91.8 81.6 172.1 17.2c26.9-21.6 60.1-22.9 82.3-3.6 18.2 15.8 40.7 30.8 68.2 43.7 27.5 12.8 53.5 20.4 77.3 24.2 29.1 4.7 49.4 30.9 50.2 65.4 2.4 102.8-39.5 209.9-39.5 209.9z",
    opacity: 1,
    "data-original": "url(#hath)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hati)",
    d: "m36.7 182.5 373.9 174.3s37.6-96.3 39.6-194L159.9 27.5c-73.6 64.3-123.2 155-123.2 155z",
    opacity: 1,
    "data-original": "url(#hati)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatj)",
    d: "M400 81.4c-23.8-3.8-49.8-11.3-77.3-24.2-8-3.7-15.6-7.7-22.7-11.7l-99.5 213.4 210.1 98s41.9-107.1 39.6-210c-.8-34.5-21.1-60.8-50.2-65.5z",
    opacity: 1,
    "data-original": "url(#hatj)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatk)",
    d: "M400 81.4c-23.8-3.8-49.8-11.3-77.3-24.2-8-3.7-15.6-7.7-22.7-11.7l-99.5 213.4 210.1 98s41.9-107.1 39.6-210c-.8-34.5-21.1-60.8-50.2-65.5z",
    opacity: 1,
    "data-original": "url(#hatk)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatl)",
    d: "M392.4 314.4c-.8-.4-1.5-.9-2.3-1.3-10.7-5.6-18.7-15.2-23-26.5-6.7-17.7-20.1-32.9-38.6-41.5-8.5-4-17.4-6.2-26.3-6.9-12-.9-23.4-5.9-31.4-14.9-5.2-5.7-11.5-10.5-19-14-7.4-3.5-15.2-5.3-22.9-5.5-12-.4-23.2-5.9-31.6-14.5-6.2-6.4-13.6-11.7-22.2-15.7-18.5-8.6-38.7-9.1-56.6-2.9-11.4 4-24 4-35.1-.6l-2.4-.9c-27.6-10-58.8 2-72.6 27.8-16.2 30.3-3.5 67.6 27.3 82 7.9 3.7 16.1 5.5 24.2 5.6 12.2.2 23.7 5.4 32.7 13.6 5.4 4.9 11.7 9.1 18.7 12.4 17.5 8.2 36.6 9 53.8 3.8 11.9-3.6 24.7-2.8 36 2.6.2.1.3.2.5.2s.3.2.5.2c11.4 5.2 20.2 14.4 25.1 25.9 7 16.5 20 30.6 37.5 38.8 7 3.3 14.3 5.4 21.5 6.4 12.1 1.7 23.5 7.1 31.4 16.4 5.3 6.2 12 11.3 19.9 15 30.8 14.3 67.5.1 80.3-31.8 10.9-27.4 0-59-25.4-73.7z",
    opacity: 1,
    "data-original": "url(#hatl)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatm)",
    d: "M8.3 197c-16.2 30.3-3.5 67.6 27.3 82 7.9 3.7 16.1 5.5 24.2 5.6 12.2.2 23.7 5.4 32.7 13.6 5.4 4.9 11.7 9.1 18.7 12.4 17.5 8.2 36.6 9 53.8 3.8 11.9-3.6 24.7-2.8 36 2.6.2.1.3.2.5.2s.3.2.5.2c11.4 5.2 20.2 14.4 25.1 25.9 7 16.5 20 30.6 37.5 38.8 7 3.3 14.3 5.4 21.5 6.4 12.1 1.7 23.5 7.1 31.4 16.4 5.3 6.2 12 11.3 19.9 15 30.8 14.3 67.5.1 80.3-31.8 5.9-14.7 5.4-30.7-.3-44.6L42.6 168.6C28.3 173.1 15.8 183 8.3 197z",
    opacity: 1,
    "data-original": "url(#hatm)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatn)",
    d: "M392.4 314.4c-.8-.4-1.5-.9-2.3-1.3-10.7-5.6-18.7-15.2-23-26.5-6.7-17.7-20.1-32.9-38.6-41.5-3.3-1.5-6.6-2.8-9.9-3.8l-63.2 135.5c2.9 1.9 6 3.6 9.3 5.1 7 3.3 14.3 5.4 21.5 6.4 12.1 1.7 23.5 7.1 31.4 16.4 5.3 6.2 12 11.3 19.9 15 30.8 14.3 67.5.1 80.3-31.8 10.9-27.2 0-58.8-25.4-73.5z",
    opacity: 1,
    "data-original": "url(#hatn)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.2,
    cy: 242.1,
    r: 75.5,
    fill: "url(#hato)",
    opacity: 1,
    "data-original": "url(#hato)",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.6,
    cy: 313.6,
    r: 75.5,
    fill: "url(#hatp)",
    opacity: 1,
    "data-original": "url(#hatp)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatq)",
    d: "M456.3 511.5h-1c-30-.1-54.3-24.4-54.4-54.4v-1c.1-30 24.4-54.3 54.4-54.4h1c30 .1 54.3 24.4 54.4 54.4v1c0 30-24.4 54.4-54.4 54.4z",
    opacity: 1,
    "data-original": "url(#hatq)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatr)",
    d: "M456.3 511.5h-1c-30-.1-54.3-24.4-54.4-54.4v-1c.1-30 24.4-54.3 54.4-54.4h1c30 .1 54.3 24.4 54.4 54.4v1c0 30-24.4 54.4-54.4 54.4z",
    opacity: 1,
    "data-original": "url(#hatr)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hats)",
    d: "M461.2 480c0-3.2 1.6-6.1 4.1-8 3.7-2.8 6.1-7.3 6.1-12.3 0-8.8-7.4-15.9-16.3-15.5-8.1.4-14.6 7.2-14.8 15.3-.1 5.2 2.4 9.8 6.3 12.7 2.5 1.8 3.9 4.8 3.9 7.8v31.3s3.2.7 4.8.7h1c1.6 0 4.8-.7 4.8-.7V480z",
    opacity: 1,
    "data-original": "url(#hats)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatt)",
    d: "M461.2 480c0-3.2 1.6-6.1 4.1-8 3.7-2.8 6.1-7.3 6.1-12.3 0-8.8-7.4-15.9-16.3-15.5-8.1.4-14.6 7.2-14.8 15.3-.1 5.2 2.4 9.8 6.3 12.7 2.5 1.8 3.9 4.8 3.9 7.8v31.3s3.2.7 4.8.7h1c1.6 0 4.8-.7 4.8-.7V480z",
    opacity: 1,
    "data-original": "url(#hatt)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hatu)",
    d: "M455.1 444.2c-8.1.4-14.6 7.2-14.8 15.3-.1 5.2 2.4 9.8 6.3 12.7.7.5 1.3 1.1 1.8 1.8h14.9c.6-.7 1.2-1.4 1.9-1.9 3.7-2.8 6.1-7.3 6.1-12.3.1-8.9-7.3-16-16.2-15.6z",
    opacity: 1,
    "data-original": "url(#hatu)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSantaHat);
export default __webpack_public_path__ + "static/media/icon_santa_hat.35371973.svg";
export { ForwardRef as ReactComponent };